import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permisos, setPermisos] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const tokenEstaExpirado = (token) => {
    try {
      const { exp } = JSON.parse(atob(token.split('.')[1]));
      return exp * 1000 < Date.now();
    } catch {
      return true;
    }
  };

  const loadUserData = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }

    if (tokenEstaExpirado(token)) {
      localStorage.removeItem('token');
      setLoading(false);
      window.location.href = '/login';
      return;
    }

    try {
      const response = await api.get('/auth/me/permisos');
      setPermisos(response.data.permisos);
      setRoles(response.data.roles);
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUser({ username: payload.sub, nombre: response.data.nombre || null });
    } catch (error) {
      console.error('Error loading user data:', error);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const hasPermission = (permission) => {
    return permisos.includes(permission);
  };

  const hasRole = (role) => {
    return roles.includes(role);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setPermisos([]);
    setRoles([]);
    window.location.href = '/login';
  };

  useEffect(() => {
    loadUserData();
  }, []);

  const value = {
    user,
    permisos,
    roles,
    loading,
    hasPermission,
    hasRole,
    logout,
    refreshUserData: loadUserData
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};